import { useCallback, useRef } from "react";

/** 選択肢ボタンの ref を集め、↑/↓ 相当のフォーカス移動を提供する。 */
export function useChoiceOptionFocus() {
	const optionButtonRefs = useRef<(HTMLButtonElement | null)[]>([]);

	const setOptionRef = useCallback(
		(index: number) => (button: HTMLButtonElement | null) => {
			optionButtonRefs.current[index] = button;
		},
		[],
	);

	const focusByOffset = useCallback((offset: number) => {
		const options = optionButtonRefs.current.filter((button): button is HTMLButtonElement =>
			Boolean(button),
		);
		if (options.length === 0) return;

		const activeIndex = options.findIndex((button) => button === document.activeElement);
		const fallbackIndex = offset > 0 ? 0 : options.length - 1;
		const nextIndex =
			activeIndex === -1
				? fallbackIndex
				: Math.min(Math.max(activeIndex + offset, 0), options.length - 1);

		options[nextIndex]?.focus();
	}, []);

	return { setOptionRef, focusByOffset };
}
